import Model from 'flarum/common/Model';

export interface OpenGraph {
    site_name?: string
    title?: string
    description?: string
    images?: {
        url: string
        alt?: string
    }[]
}

export interface Icon {
    href: string
    sizes?: 'any' | {
        width: number
        height: number
    }[]
    type?: string
}

export interface Fallback {
    title?: string
    description?: string
    images?: {
        src: string
        alt?: string
    }[]
}

export interface Preview {
    icon?: string
    siteName?: string
    contentType?: string
    title?: string
    inlineTitle?: string
    description?: string
    duration?: string // Will use ISO8601 from YouTube API
    author?: {
        avatarUrl?: string
        username: string
        url?: string
    }
    images?: {
        src: string
        alt?: string
    }[]
    stats?: {
        icon: string
        label: string
        value: string
        url?: string
        date?: boolean
        bytes?: boolean
        number?: boolean
    }[]
}

export default class Embed extends Model {
    domain = Model.attribute<string>('domain');
    finalUrl = Model.attribute<string>('finalUrl');
    mime = Model.attribute<string | null>('mime');
    opengraph = Model.attribute<OpenGraph | null>('opengraph');
    icons = Model.attribute<Icon[] | null>('icons');
    fallback = Model.attribute<Fallback | null>('fallback');
    exif = Model.attribute<any>('exif');
    width = Model.attribute<number | null>('width');
    height = Model.attribute<number | null>('height');
    size = Model.attribute<number | null>('size');
    state = Model.attribute<'retrieving' | 'error' | 'ready'>('state');
    preview = Model.attribute<Preview | null>('preview');
    canRefresh = Model.attribute<boolean>('canRefresh');

    hasContent(includingFallback: boolean = false): boolean {
        return !!this.preview();
    }
}
